import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/roles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::index
* @see app/Http/Controllers/Admin/Roles/RoleController.php:27
* @route '/roles'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/roles/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::create
* @see app/Http/Controllers/Admin/Roles/RoleController.php:114
* @route '/roles/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::store
* @see app/Http/Controllers/Admin/Roles/RoleController.php:121
* @route '/roles'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/roles',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::store
* @see app/Http/Controllers/Admin/Roles/RoleController.php:121
* @route '/roles'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::store
* @see app/Http/Controllers/Admin/Roles/RoleController.php:121
* @route '/roles'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::store
* @see app/Http/Controllers/Admin/Roles/RoleController.php:121
* @route '/roles'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::store
* @see app/Http/Controllers/Admin/Roles/RoleController.php:121
* @route '/roles'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
export const edit = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/roles/{role}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
edit.url = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { role: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: typeof args.role === 'object'
        ? args.role.slug
        : args.role,
    }

    return edit.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
edit.get = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
edit.head = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
const editForm = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
editForm.get = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::edit
* @see app/Http/Controllers/Admin/Roles/RoleController.php:128
* @route '/roles/{role}/edit'
*/
editForm.head = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::update
* @see app/Http/Controllers/Admin/Roles/RoleController.php:136
* @route '/roles/{role}'
*/
export const update = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/roles/{role}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::update
* @see app/Http/Controllers/Admin/Roles/RoleController.php:136
* @route '/roles/{role}'
*/
update.url = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { role: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: typeof args.role === 'object'
        ? args.role.slug
        : args.role,
    }

    return update.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::update
* @see app/Http/Controllers/Admin/Roles/RoleController.php:136
* @route '/roles/{role}'
*/
update.put = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::update
* @see app/Http/Controllers/Admin/Roles/RoleController.php:136
* @route '/roles/{role}'
*/
const updateForm = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Roles\RoleController::update
* @see app/Http/Controllers/Admin/Roles/RoleController.php:136
* @route '/roles/{role}'
*/
updateForm.put = (args: { role: string | { slug: string } } | [role: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const roles = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default roles